import ScrollMagic from 'scrollmagic'
import 'scrollmagic/scrollmagic/minified/plugins/animation.gsap.min.js'
import 'scrollmagic/scrollmagic/minified/plugins/debug.addIndicators.min.js'

var controller = new ScrollMagic.Controller();

export default {
  inserted: (el, binding) => {

    // GENERATE TRIGGER ELEMENT
    let className = "";
    const characters = "abcdefghijklmnopqrstuvwxyz";
    for (var i = 0; i < 5; i++) {
      className += characters.charAt(Math.floor(Math.random() * characters.length));
    }

    const triggerElement = document.createElement('div');
    triggerElement.setAttribute("class", 'trigger-' + className);
    el.prepend(triggerElement);

    // SET SCROLL MAGIC SCENE
    const defaultSceneOptions = {
      duration: 0,
      offset: 0,
      triggerElement: triggerElement,
      triggerHook: 0.8,
      reverse: false,
      loglevel: 2
    }

    const sceneOptions = Object.assign(defaultSceneOptions, binding.value);

    const scene = new ScrollMagic.Scene(sceneOptions)
      .setClassToggle(el, "animate")

    // ANIMATE WITH TWEENMAX
    // if (binding.value.TweenMax) {
    //   let TweenMaxAnimations;
    //   try {
    //     TweenMaxAnimations = binding.value.TweenMax
    //   } catch (error) {
    //     console.log(error);
    //   }

    //   scene.setTween(TweenMax.to(el, defaultSceneOptions.duration / 1000, TweenMaxAnimations))
    // }

    scene.addTo(controller)

    if (binding.arg) {
      scene.addIndicators();
    }
  }
}